import React from "react";
import { Filters, IFiltersProps } from "@comparaonline/ui-filter-list";

import { useModalProps } from "./hooks";

export interface BaseFilterProps extends Pick<IFiltersProps, "filterGroups"> {
  loading: boolean;
}

export const BaseFilter: React.FC<BaseFilterProps> = ({ loading, filterGroups }) => {
  const modalOptions = useModalProps();
  return loading ? (
    <Filters showSkeleton={true} skeletonsToShow={3} filterGroups={[]} />
  ) : (
    <Filters filterGroups={filterGroups} {...modalOptions} />
  );
};
